import { render, staticRenderFns } from "./memberShareWithdrawBnb.vue?vue&type=template&id=82279d00&scoped=true"
import script from "./memberShareWithdrawBnb.vue?vue&type=script&lang=js"
export * from "./memberShareWithdrawBnb.vue?vue&type=script&lang=js"
import style0 from "./memberShareWithdrawBnb.vue?vue&type=style&index=0&id=82279d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82279d00",
  null
  
)

export default component.exports